__turbopack_context__.v({
  "dot": "MobileCarouselDots-module__A1Gbaa__dot",
  "dotActive": "MobileCarouselDots-module__A1Gbaa__dotActive",
  "dots": "MobileCarouselDots-module__A1Gbaa__dots",
});
